const options = {
	method: 'GET',
	headers: {
		'Accept-Language': Shopify.locale || 'de',
		'accept': 'application/json',
	},
};
const sleep = (milliseconds) => {
	return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
class ReviewsIoDataLoader {
	constructor(storeID, SKUs) {
		this.storeID = storeID;
		this.SKUs = SKUs;
		this._fetchedData = [];
	}
	get fetchedData() {
		return this._fetchedData;
	}
	get uniqueFetchedData() {
		// each review has an 'id' field, we can use it to filter unique reviews
		const uniqueReviewsMap = new Map();
		this._fetchedData.forEach((review) => {
			uniqueReviewsMap.set(`${review.author.name}-${review.author.location}`, review);
		});
		return Array.from(uniqueReviewsMap.values());
	}
	async fetchReviews({ count = 10, type = 'product_review', minRating, withFilter, page }) {
		// https://developer.reviews.io/reference/899f58c2c4431ec1000ec59a38b2916b
		// Max is 200 per request
		// type: store_review, product_review, store_third_party_review or questions.
		// with: images, videos or media
		const paramsObj = {
			type: type,
			store: this.storeID,
			per_page: count,
			lang: Shopify.locale || 'de',
		};
		this.SKUs && (paramsObj.sku = this.SKUs);
		withFilter && (paramsObj.with = withFilter);
		page && (paramsObj.page = page);
		minRating && (paramsObj.minRating = minRating);
		const queryParameters = new URLSearchParams(paramsObj);
		return await fetch(`https://api.reviews.co.uk/reviews?${queryParameters.toString()}`, options)
			.then((response) => response.json())
			.catch((error) => {
				console.error('Error:', error);
				return null;
			});
	}
	async startLoading({ totalCount = 200, type = 'product_review', minRating, withFilter, timeOut = 1000, onBatch } = {}) {
		const itemsPerPage = Math.min(10, totalCount);
		for (let currentPageNumber = 1; this._fetchedData.length < totalCount; currentPageNumber++) {
			const responseData = await this.fetchReviews({
				count: itemsPerPage,
				type,
				minRating,
				withFilter,
				page: currentPageNumber,
			});
			const reviewsArray = Array.isArray(responseData?.reviews) ? responseData.reviews : [];
			this._fetchedData = this._fetchedData.concat(reviewsArray);
			if (onBatch) onBatch();
			// If fewer than a full page returned, we reached the last page
			if (reviewsArray.length < itemsPerPage) {
				break;
			}
			await sleep(timeOut);
		}
		return this._fetchedData;
	}
}
export { ReviewsIoDataLoader };
